export const CHANNELS_REQUEST = 'channelsRequest';
export const CHANNELS_FAILURE = 'channelsFailure';
export const CHANNELS_SUCCESS = 'channelsSuccess';
